import { updateCheckedForClf } from '../../utils/commonMethods/generalMethodsExtended';
import { getPaginatedChunkData } from '../../utils/commonUtil';
import { DATATABLE_INITIAL_STATE, SB_DATA_ERROR } from './constants';

export const sbDataTableReducers = (
  state: SbDataTableState,
  action: SbDataTableAction,
) => {
  const calculatedPageNum = action.payload.paginationData.page;
  const prevPage = state.paginationData.page;
  const chunkData = getPaginatedChunkData(
    calculatedPageNum,
    action.payload.SbBrowserData,
    action.payload.paginationData.rowPerPage,
    prevPage,
    state.paginationData.start,
    state.total_records,
  );
  return ({
    ...state,
    paginationData: {
      start: action.payload.paginationData.start,
      end: action.payload.paginationData.end,
      rowPerPage: action.payload.paginationData.rowPerPage,
      page: action.payload.paginationData.page,
      selectedChunkData: chunkData,
    },
  });
};
export const ColumnLevelPending = (
  state: SbDataTableState,
) => ({
  ...state,
  isColumnDataLoading: true,
});

export const ColumnLevelRejected = (state: SbDataTableState) => {
  return {
    ...state,
    isColumnDataLoading: false,
    errorMessage: SB_DATA_ERROR,
    FilterData: DATATABLE_INITIAL_STATE.FilterData,
  };
};

export const ColumnLevelFullfilled = (state: SbDataTableState, action: SbDataTableAction) => {
  return {
    ...state,
    isColumnDataLoading: false,
    FilterData: action.payload.records,
  };
};

export const ColumnFilterStateUpdate = (state: SbDataTableState, action: SbDataTableAction) => {
  return {
    ...state,
    isColumnDataLoading: false,
    FilterState: action.payload.records,
  };
};

export const ColumnFilterPayloadUpdate = (state: SbDataTableState, action: SbDataTableAction) => {
  return {
    ...state,
    isColumnDataLoading: false,
    FilterPayload: action.payload.records,
  };
};
export const setDataTableColumns = (state: SbDataTableState, action: SbDataTableAction) => {
  return ({
    ...state,
    columns: action.payload.columns,
  });
};
export const setConcurrentToggle = (state: SbDataTableState, action: SbDataTableAction) => {
  return {
    ...state,
    concurrentToggle: action.payload.concurrentToggle,
  };
};
export const setSbStatusViewToggle = (state: SbDataTableState, action: SbDataTableAction) => {
  return {
    ...state,
    sbStatusViewToggle: action.payload.sbStatusViewToggle,
  };
};
export const setSelectedSbClfReducer = (state: SbDataTableState, action: sbSelectedClfActionType) => {
  const sbClfState = { ...state.browserTableClfState };
  Object.entries(action.payload.filterObject).forEach(([key, value]) => {
    sbClfState[key as keyof browserTableClfStateType] = updateCheckedForClf(sbClfState[key as keyof browserTableClfStateType], value);
  });
  return {
    ...state,
    browserTableClfState: sbClfState,
  };
};

export const setSBClfStateReducer = (state: SbDataTableState, action: setSBClfStateActionType) => {
  return {
    ...state,
    browserTableClfState: {
      ...state.browserTableClfState,
      [action.payload.filterName]: {
        ...action.payload.filterValues,
      },
    },
  };
};
